import { Button, Group, Stack, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconUsers } from "@tabler/icons-react";
import { Suspense } from "react";
import { BadgeItem } from "shared/components/global/BadgeItem";
import { ComposeFormProvider, useComposeFormContext } from "shared/components/message/compose/context";
import { GroupSelector } from "shared/components/organization/groups/groups";
import { useFormSubscription } from "shared/hooks/useFormSubscription";
import { GroupLikeFragment } from "src/gql/graphql";

const GroupSelectModal = () => {
    const form = useComposeFormContext();
    const groups = useFormSubscription(form, "audience.groups");

    function handleGroupCheckboxChange(grp: GroupLikeFragment, checked: boolean) {
        form.setFieldValue("audience.groups", (prev) => {
            if (checked) return prev.concat([grp]);
            else return prev.filter(({ id }) => id != grp.id);
        });
    }

    return (
        <GroupSelector
            selectedGroups={groups}
            onChange={handleGroupCheckboxChange}
            shouldDisable={() => false}
            containerStyle={{ maxHeight: "75dvh" }}
        />
    );
};

export const AudienceGroupEditor = () => {
    const form = useComposeFormContext();
    const groups = useFormSubscription(form, "audience.groups");

    function handleDeleteGroup(idx: number) {
        form.setFieldValue("audience.groups", (prev) => prev.toSpliced(idx, 1));
    }

    return (
        <Stack>
            <div>
                <Text fw="bold">Groups</Text>
                <Text c="dimmed" size="xs">
                    Send to users within a group.
                </Text>
            </div>
            <Button
                variant="default"
                leftSection={<IconUsers size={16} />}
                onClick={() =>
                    modals.open({
                        title: "Select Groups",
                        size: "lg",
                        children: (
                            <Suspense>
                                <ComposeFormProvider form={form}>
                                    <GroupSelectModal />
                                </ComposeFormProvider>
                            </Suspense>
                        ),
                    })
                }
            >
                Add Groups
            </Button>
            <Group>
                {groups.map((grp, i) => (
                    <BadgeItem size="lg" key={grp.id + i} onDelete={() => handleDeleteGroup(i)}>
                        {grp.name}
                    </BadgeItem>
                ))}
            </Group>
        </Stack>
    );
};
